import { Trans, useLingui } from '@lingui/react';
import './how-it-works.scss';
import carDetails from './images/hiw-icon-cardetails.webp';
import recieveMoney from './images/hiw-icon-recieve-money.webp';
import recieveMoneySE from './images/hiw-icon-recieve-money-se.png';
import trueOffer from './images/hiw-icon-true-offer.webp';
import trueOfferSE from './images/hiw-icon-true-offer-se.png';
import { scrollNextField } from '../../../helpers/scrollNextField';
import { useAppConfiguration } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FullwidthWrapper = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "box gap how-it-works-wrapper",
    "data-selector": "how-it-works",
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: children
    })
  });
};
export function HowItWorks(_ref2) {
  let {
    showCTA = false
  } = _ref2;
  const {
    i18n
  } = useLingui();
  const {
    locale
  } = useAppConfiguration();
  const receiveMoneyImage = locale === 'sv-SE' ? recieveMoneySE : recieveMoney;
  const trueOfferImage = locale === 'sv-SE' ? trueOfferSE : trueOffer;
  const selfEva = typeof window !== 'undefined' ? /self-inspection/.test(window.location.href) : '';
  const title = selfEva ? i18n._('selfInspection.howItWorks.title') : i18n._('carlead.howItWorks.title');
  const hiwItems = [{
    image: trueOfferImage,
    title: selfEva ? i18n._('selfInspection.howItWorks.title') : i18n._('carlead.howItWorks.entry1.title'),
    text: selfEva ? i18n._('selfInspection.howItWorks.entry1.text') : i18n._('carlead.howItWorks.entry1.text')
  }, {
    image: carDetails,
    title: selfEva ? i18n._('selfInspection.howItWorks.entry2.title') : /*#__PURE__*/_jsx(Trans, {
      id: "carlead.howItWorks.entry2.title",
      components: {
        0: /*#__PURE__*/_jsx("br", {})
      }
    }),
    text: selfEva ? i18n._('selfInspection.howItWorks.entry2.text') : i18n._('carlead.howItWorks.entry2.text')
  }, {
    image: receiveMoneyImage,
    title: selfEva ? i18n._('selfInspection.howItWorks.entry3.title') : /*#__PURE__*/_jsx(Trans, {
      id: "carlead.howItWorks.entry3.title",
      components: {
        0: /*#__PURE__*/_jsx("br", {
          className: "hidden-xs hidden-ms"
        })
      }
    }),
    text: selfEva ? i18n._('selfInspection.howItWorks.entry3.text') : i18n._('carlead.howItWorks.entry3.text')
  }];
  return /*#__PURE__*/_jsxs("section", {
    className: "how-it-works",
    children: [/*#__PURE__*/_jsx("h2", {
      className: "section-title",
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: "row",
      children: hiwItems.map((item, index) => /*#__PURE__*/_jsx("div", {
        className: "col-md-4",
        children: /*#__PURE__*/_jsxs("div", {
          className: "how-it-works__item",
          children: [/*#__PURE__*/_jsx("div", {
            className: "how-it-works__image image-icon-" + ++index + " mr-3 mr-md-0",
            children: /*#__PURE__*/_jsx("img", {
              className: "svg-icon",
              src: item.image,
              alt: item.title
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("h4", {
              className: "how-it-works__title",
              children: item.title
            }), /*#__PURE__*/_jsx("p", {
              dangerouslySetInnerHTML: {
                __html: item.text
              }
            })]
          })]
        })
      }, index))
    }), showCTA && /*#__PURE__*/_jsx(HowItWorksCTA, {})]
  });
}
function HowItWorksCTA() {
  const {
    i18n
  } = useLingui();
  const ctaLabel = i18n._('carleadCreation.form.button');
  const handleScroll = () => {
    scrollNextField();
  };
  return /*#__PURE__*/_jsx("div", {
    className: "row justify-content-center",
    children: /*#__PURE__*/_jsxs("button", {
      className: "btn btn-secondary btn-lg btn-arrow goToNextField",
      onClick: handleScroll,
      "data-tracking": "true",
      "data-action": "Click",
      "data-label": "CTA - How It Works",
      children: [ctaLabel, /*#__PURE__*/_jsx("svg", {
        className: "svg-icon ml-2",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/_jsx("path", {
          d: "m23.999 18 2-2-16-16L6 3.999 17.998 16 6 28.001 9.999 32l14-14z"
        })
      })]
    })
  });
}
export function CarleadHowItWorks(props) {
  return /*#__PURE__*/_jsx(FullwidthWrapper, {
    children: /*#__PURE__*/_jsx(HowItWorks, {
      ...props
    })
  });
}
export default CarleadHowItWorks;